import { type UseQueryOptions, useQuery } from '@tanstack/vue-query'
import type { MaybeRefOrGetter } from 'vue'
import { computed, toValue } from 'vue'
import { HR_REMINDERS_COUNT } from '../reminderEndpoints'
import { REMINDERS_COUNT_QUERY_KEY } from '../reminderQueryKeys'
import { axiosInstance } from '@/modules/Core/plugins/axios'
import type { RemindersCountDto } from '@/modules/Reminder/types/api/reminder'

export interface FetchRemindersCountParams {
  from?: string | null
  to?: string | null
}

export function fetchRemindersCount(
  params: FetchRemindersCountParams
): Promise<RemindersCountDto> {
  return axiosInstance
    .get<RemindersCountDto>(HR_REMINDERS_COUNT, {
      params: {
        ...(params.from ? { From: params.from } : {}),
        ...(params.to ? { To: params.to } : {}),
      },
    })
    .then((response) => response.data)
}

export function useRemindersCountQuery(
  params: MaybeRefOrGetter<FetchRemindersCountParams>,
  options?: Omit<
    UseQueryOptions<Awaited<ReturnType<typeof fetchRemindersCount>>>,
    'queryKey' | 'queryFn'
  >
) {
  return useQuery({
    queryKey: computed(() => [REMINDERS_COUNT_QUERY_KEY, toValue(params)]),
    queryFn: () => fetchRemindersCount(toValue(params)),
    ...options,
  })
}
